import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { StatisticsType, layoutOptions } from "./types/prop-types";

/** Statistics Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.ExtraSmall,
};

export const Statistics = secondaryBlock<StatisticsType>(
  blockConfig,
  ({
    primaryButtonText,
    primaryButtonLink,
    secondaryButtonLink,
    secondaryButtonText,
    tertiaryButtonText,
    tertiaryButtonLink,
    statistics,
  }: StatisticsType) => (
    <Box className="secondary-statistics-extrasmall-v1 margin-section-xsmall direction-vertical">
      <Box sx={{ display: "block" }}>
        <Variants.ButtonGroup
          primaryButtonText={primaryButtonText}
          primaryButtonLink={primaryButtonLink}
          secondaryButtonText={secondaryButtonText}
          secondaryButtonLink={secondaryButtonLink}
          tertiaryButtonText={tertiaryButtonText}
          tertiaryButtonLink={tertiaryButtonLink}
        />
      </Box>
      <Box className="list-component-xsmall list-item-xsmall vertical-on-mobile">
        {statistics?.map((statistic, index) => (
          <Box className="list-item-xsmall vertical-on-mobile" key={index}>
            {index !== 0 && (
              <Variants.DividerVertical className="hide-mobile" />
            )}
            <Box className="item-xsmall">
              {statistic.number && (
                <Variants.ParagraphSmall
                  bold
                  className="text-size-small text-weight-bold margin-right-xsmall"
                >
                  {statistic.number}
                </Variants.ParagraphSmall>
              )}
              {statistic.description && (
                <Variants.ParagraphSmall>
                  {statistic.description}
                </Variants.ParagraphSmall>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
);

Statistics.defaultProps = getDefaultProps<StatisticsType>(defaults);

export const Element: KameleonElement = {
  component: Statistics,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
